import TitleContainer from "../Layout/TitleContainer";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {loadArticles, loadArticle} from "../../store/actions/article";
import {Link, useLocation, useNavigate} from "react-router-dom";
import queryString from "query-string"
import dayjs from "dayjs";

const Notice = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = queryString.parse(location.search);
    const { page, page_count, articles, article, loading } = useSelector((state) => state.article);
    const dispatch = useDispatch();
    useEffect(() => {
        if (id) {
            dispatch(loadArticle(id));
        }
        dispatch(loadArticles(4959308929423, 1));
    }, [id]);

    const setPage = (i) => {
        if (i === page || i < 1 || i > page_count) return;
        dispatch(loadArticles(4959308929423, i));
    }

    let contents;
    if (id) {
        contents = <>
            <div className="section-block clearfix pt-0 pb-0 bkg-grey-ultralight">
                <div className="row">

                    <div className="column width-10 offset-1 content-inner blog-single-post">
                        <article className="post">
                            <div className="post-content with-background">
                                <h2 className="post-title center">{article.title}</h2>
                                <div className="post-info center">
                                    <span className="post-date">{dayjs(article.created_at).format('YYYY-MM-DD')}</span>
                                </div>
                                <div className="post-content" dangerouslySetInnerHTML={{ __html: article.body }} />
                            </div>
                        </article>
                    </div>
                </div>
            </div>

            <div className="section-block pagination-3 portfolio bkg-grey-ultralight">
                <div className="row">
                    <div className="column width-10 offset-1">
                        <ul>
                            <li><a className="back-to-grid fade-location" href="#" onClick={() => navigate(-1)}>목록</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    } else {
        contents = <>
            <div className="section-block clearfix pt-0 pb-0 bkg-grey-ultralight">
                <div className="row">
                    <div className="column width-10 offset-1 content-inner blog-regular list">
                        {articles.map((article) => (
                            <article className="post" key={article.id}>
                                <div className="post-content with-background">
                                    <h2 className="post-title"><Link to={`/support/notice?id=${article.id}`}>{article.title}</Link></h2>
                                    <div className="post-info">
                                        <span className="post-date">{dayjs(article.created_at).format('YYYY-MM-DD')}</span>
                                    </div>
                                    <Link to={`/support/notice?id=${article.id}`} className="read-more">더 읽어보기 →</Link>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </div>

            <div className="section-block pagination-3 bkg-grey-ultralight">
                <div className="row">
                    <div className="column width-10 offset-1">
                        <ul>
                            <li><a className={`pagination-previous ${page === 1 ? 'disabled' : ''}`} href="#" onClick={() => setPage(page - 1)}><span
                                className="icon-left-open-mini"></span></a></li>
                            {
                                Array(page_count)
                                    .fill()
                                    .map((_, i) => (
                                        <li key={i + 1}><a className={page === i + 1 ? "current" : undefined} href="#" onClick={() => setPage(i + 1)}>{i + 1}</a></li>
                                    ))
                            }
                            <li><a className={`pagination-next ${page === page_count ? 'disabled' : ''}`} href="#" onClick={() => setPage(page + 1)}><span
                                className="icon-right-open-mini"></span></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    }

    return (
        <>
            <TitleContainer title="공지사항" description="공지사항을 확인하실 수 있습니다" style={{'bkg-grey-ultralight': true}} />

            {loading && <div className="section-block replicable-content bkg-grey-ultralight">
                <div className="row">
                    <div className="column width-12 center">
                        <span
                            className="icon-circled icon-cycle medium border-dribbble color-dribbble pulsate" />
                    </div>
                </div>
            </div>}

            {contents}
        </>
    )
};

export default Notice;